module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-75-SemiBold.7f05e058.ttf";